// Static Images
import DownloadIcon from '../../static/images/downloadIcon.png';
import downArrowImg from '../../static/images/down-arrow.png';

// Components
import { FormElems } from '../../components/';
import { ERROR_MESSAGES } from '../../utils/constants/toastMessages';
import { generateCSVFromArray } from '../../utils/helperMethods';

import DownloadPreFilledFileFilter from './DownloadPreFilledFileFilter';

// Constants
import {
    SAMPLE_FILE_NAME,
    SAMPLE_FILE_SCHEMA,
    UPLOAD_FILE_STATUS_ENUM,
} from './constant';

// Libraries
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const filePlaceHolder = { name: 'Upload .CSV File' };

const statusLabel = (fileUploadStatus, fileName) => {
    switch (fileUploadStatus) {
        case UPLOAD_FILE_STATUS_ENUM.DEFAULT:
            return <span>Maximum 1000 refund per file is allowed</span>;
        case UPLOAD_FILE_STATUS_ENUM.UPLOADING:
            return (
                <span>
                    {fileName} is{' '}
                    <span className="uploadingTextColor">Uploading...</span>
                </span>
            );
        case UPLOAD_FILE_STATUS_ENUM.FAILED:
            return (
                <span>
                    {fileName} is{' '}
                    <span className="failedTextColor">Failed to upload</span>
                </span>
            );
        case UPLOAD_FILE_STATUS_ENUM.SUCCESS:
            return (
                <span className="successTextColor">
                    {fileName} file is Uploaded
                </span>
            );
        default:
            return <span>Maximum 1000 refund per file is allowed</span>;
    }
};

const BulkRefundHeader = ({ uploadFile, userLevel, bulkRefundData, auth }) => {
    const [showPopUp, setShowPopUp] = useState(false);
    const [selectedFile, setSelectedFile] = useState(filePlaceHolder);
    const [uploadFileLabel, setUploadFileLabel] = useState(
        statusLabel(UPLOAD_FILE_STATUS_ENUM.DEFAULT)
    );
    const [uploadFileStatus, setUploadFileStatus] = useState(
        UPLOAD_FILE_STATUS_ENUM.DEFAULT
    );

    const togglePopUp = () => {
        setShowPopUp(!showPopUp);
    };

    const handleDownloadSampleFile = () => {
        generateCSVFromArray(SAMPLE_FILE_SCHEMA, SAMPLE_FILE_NAME);
    };

    useEffect(() => {
        setUploadFileLabel(statusLabel(uploadFileStatus, selectedFile.name));
    }, [selectedFile.name, uploadFileStatus]);

    useEffect(() => {
        if (bulkRefundData.uploadFile.isSuccess === null) {
            setUploadFileStatus(UPLOAD_FILE_STATUS_ENUM.DEFAULT);
        } else if (bulkRefundData.uploadFile.isSuccess === true) {
            setUploadFileStatus(UPLOAD_FILE_STATUS_ENUM.SUCCESS);
        } else if (bulkRefundData.uploadFile.isSuccess === false) {
            setUploadFileStatus(UPLOAD_FILE_STATUS_ENUM.FAILED);
        }
    }, [bulkRefundData.uploadFile.isSuccess]);

    const handleFileChange = (value, event) => {
        event.preventDefault();
        const files = event.target.files[0];
        setUploadFileStatus(UPLOAD_FILE_STATUS_ENUM.UPLOADING);
        if (files && /.+(\.csv)$/.test(files.name)) {
            setSelectedFile(files);
            const formData = new FormData();
            formData.append('inputFile', event.target.files[0]);
            uploadFile(formData);
        } else {
            setUploadFileStatus(UPLOAD_FILE_STATUS_ENUM.FAILED);
            toast.info(ERROR_MESSAGES.ONLY_CSV_FILE);
        }
    };

    return (
        <div className="bulk-refund-wrapper-header">
            <h3 className="page-tile">Bulk Refund</h3>
            <div className="bulk-refund-wrapper-actions">
                <ul className="download-actions">
                    <li onClick={handleDownloadSampleFile}>
                        <img
                            src={DownloadIcon}
                            alt="Download"
                            className="download-icon"
                        />
                        <div className="action-text">
                            <p>Download Sample File</p>
                            <label>File will be download without data</label>
                        </div>
                    </li>
                    <li className="download-prefilled-container">
                        <FilterPopupUp
                            showPopUp={showPopUp}
                            togglePopUp={togglePopUp}
                            customComponent={
                                <DownloadPreFilledFileFilter
                                    userLevel={userLevel}
                                    showOverlay
                                    closeFilter={togglePopUp}
                                />
                            }
                        >
                            <div
                                onClick={togglePopUp}
                                className="download-prefilled-customClass"
                            >
                                <img
                                    src={DownloadIcon}
                                    alt="Download"
                                    className="download-icon"
                                />
                                <div className="action-text">
                                    <div className="action-text-left">
                                        <p>Download Pre-Filled File</p>
                                        <label>
                                            File will be download with data
                                        </label>
                                    </div>
                                    <img
                                        src={downArrowImg}
                                        alt="downArrow"
                                        className={`action-text-right ${
                                            showPopUp ? 'rotate' : ''
                                        }`}
                                    />
                                </div>
                            </div>
                        </FilterPopupUp>
                    </li>
                    {['MERCHANT', 'MLE'].includes(
                        auth?.userDetails?.userLevel
                    ) ? (
                            <li
                                className={`${
                                    ['MERCHANT', 'MLE'].includes(
                                    auth?.userDetails?.userLevel
                                    )
                                        ? ''
                                        : 'disabled'
                                }`}
                            >
                                <label
                                    htmlFor="UploadBinFile"
                                    className="file-label"
                                >
                                    <img
                                        src={DownloadIcon}
                                        alt="Download"
                                        className="download-icon"
                                    />
                                    <div className="action-text">
                                        <p>Upload File</p>
                                        <label>{uploadFileLabel}</label>
                                    </div>
                                </label>
                                <form encType="multipart/form-data" action="">
                                    <FormElems.Input
                                        name="uploadFile"
                                        type="file"
                                        id="UploadBinFile"
                                        wrapperClass="fileInput"
                                        defaultValue="fileName"
                                        input="true"
                                        accept=".csv"
                                        handleChange={handleFileChange}
                                        disabled={
                                            !['MERCHANT', 'MLE'].includes(
                                            auth?.userDetails?.userLevel
                                            )
                                        }
                                    />
                                </form>
                            </li>
                        ) : (
                            <></>
                        )}
                </ul>
            </div>
        </div>
    );
};

const FilterPopupUp = ({ showPopUp, children, customComponent }) => {
    return (
        <>
            <div className="filterPopupUp-container">
                {children}
                {showPopUp ? customComponent : null}
            </div>
        </>
    );
};

FilterPopupUp.propTypes = {
    showPopUp: PropTypes.bool,
    children: PropTypes.node,
    customComponent: PropTypes.node,
    togglePopUp: PropTypes.func,
};

BulkRefundHeader.propTypes = {
    uploadFile: PropTypes.func,
    userLevel: PropTypes.string,
    bulkRefundData: PropTypes.object,
    auth: PropTypes.object,
};

const mapStateToProps = ({ bulkRefundData, auth }) => ({
    bulkRefundData,
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BulkRefundHeader);
